import { createFileRoute } from '@tanstack/react-router';
import { motion } from 'motion/react';
import { Chapter1 } from './-components/chapter-1';
import { Chapter2 } from './-components/chapter-2';
import { Chapter3 } from './-components/chapter-3';
import { Chapter4 } from './-components/chapter-4';

export const Route = createFileRoute('/www/.internal/architecture')({
	head: () => ({
		meta: [{ name: 'robots', content: 'noindex, nofollow' }],
		title: 'Server Cache in Cluster Mode',
	}),
	component: ArchitecturePage,
});

function ArchitecturePage() {
	return (
		<div className="min-h-dvh bg-slate-50">
			<div className="border-b border-slate-200/80 bg-white">
				<div className="mx-auto max-w-4xl px-4 py-10 sm:px-6 sm:py-14">
					<motion.div
						className="flex flex-col gap-3"
						initial={{ opacity: 0, y: 20 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.5 }}
					>
						<div className="flex items-center gap-3">
							<div className="flex h-10 w-10 items-center justify-center rounded-xl bg-slate-900">
								<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
									<rect x="2" y="3" width="16" height="5" rx="1.5" stroke="white" strokeWidth="1.5" />
									<rect x="2" y="12" width="16" height="5" rx="1.5" stroke="white" strokeWidth="1.5" />
									<circle cx="5" cy="5.5" r="1" fill="white" />
									<circle cx="5" cy="14.5" r="1" fill="white" />
									<line x1="10" y1="8" x2="10" y2="12" stroke="white" strokeWidth="1.5" strokeDasharray="2 2" />
								</svg>
							</div>
							<h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
								Server Cache Architecture
							</h1>
						</div>
						<p className="max-w-2xl text-sm text-slate-500 sm:text-base">
							A visual walkthrough of how the in-memory cache works in Node.js cluster mode — from single-server
							simplicity to multi-worker coordination.
						</p>

						<div className="mt-3 flex flex-wrap items-center gap-2">
							{[
								{ id: 'chapter-1', label: 'LRU Cache' },
								{ id: 'chapter-2', label: 'Event-Loop' },
								{ id: 'chapter-3', label: 'IPC Sync' },
								{ id: 'chapter-4', label: 'Stampede' },
							].map((ch, i) => (
								<a
									key={ch.id}
									href={`#${ch.id}`}
									className="flex items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-3 py-1.5 text-xs font-medium text-slate-600 transition-colors hover:border-slate-300 hover:bg-slate-100"
								>
									<span className="flex h-4 w-4 items-center justify-center rounded bg-slate-800 text-[9px] font-bold text-white">
										{i + 1}
									</span>
									{ch.label}
								</a>
							))}
						</div>
					</motion.div>
				</div>
			</div>

			<main className="mx-auto flex max-w-4xl flex-col gap-8 px-4 py-8 sm:px-6 sm:py-12">
				<Chapter1 />
				<Chapter2 />
				<Chapter3 />
				<Chapter4 />
			</main>
		</div>
	);
}
